<template>
    <div id="app">
      
      
         

            <genelsatissozlesme ref="genelsatissozlesme"></genelsatissozlesme>

            <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                    {{ $t('Products') }}
                </v-toolbar-title>

                <v-spacer></v-spacer>


            </v-toolbar>

            <v-dialog v-if="octetKrediKartiDialog" v-model="octetKrediKartiDialog" max-width="800px">
                <v-card>
                    <v-card-text>

                        <iframe width="100%" height="500" :src="octetReturnUrl" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>

                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog  v-model="fatDialog"  persistent  width="1024" >
                <v-form v-model="isFatValid">
                <v-card   >
                  
       
           
          
            
            
         
           
     
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
               
                <v-flex xs12 sm12 md12>
                <h4>Fatura Bilgileri:</h4>
                <hr></hr>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatUnvan" label="Ünvan*" required :rules="[v => !!v || 'Ünvan Alanı Boş Bırakılamaz']"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatVergiDairesi" label="Vergi Dairesi*" :rules="[v => !!v || 'Vergi Dairesi Boş Bırakılamaz']" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatVergiNo" label="Vergi No*" :rules="[v => !!v || 'Vergi No Boş Bırakılamaz']" required></v-text-field>
              </v-flex>
           
              <v-flex xs12>
                <v-textarea v-model="fatAcikAdres" :rules="[v => !!v || 'Açık Adres Boş Bırakılamaz']"
          label="Açık Adres" required 
        ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Posta Kodu" v-model="fatPostaKod" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatSehir" label="Şehir*" :rules="[v => !!v || 'Şehir Alanı Boş Bırakılamaz']" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatIlce" label="İlçe" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-autocomplete v-model="fatUlke"
                  :items="['Türkiye', 'Almanya', 'İngiltere']"
                  label="Ülke" required :rules="[v => !!v || 'Ülke Alanı Boş Bırakılamaz']"
                ></v-autocomplete>
              </v-flex>
           
            </v-layout>
          </v-container>
          <small>*işaretli alanlar zorunludur</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="fatDialog = false">Vazgeç</v-btn>
          <v-btn color="blue darken-1" flat @click="FaturaBilgileriGuncelle()" :disabled="!isFatValid">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    </v-dialog>

            <navi v-model="drawer"></navi>
            <altaciklama></altaciklama>
            <div>
                <v-content>
                    <v-container fluid>
                        <div v-if="urunekrani">

                            <v-flex xs6 sm6 md6>
                                <v-radio-group hide-details v-model="sirkettipi" row>
                                    <v-radio :label="$t('Existing-Company')" value="0"></v-radio>
                                    <v-radio :label="$t('New-Company')" value="1"></v-radio>
                                </v-radio-group>
                            </v-flex>

                            <v-flex xs12 v-if="sirkettipi==0" sm6 md3>
                                <v-select item-value="id" item-text="text" :label="$t('Select-Your-Main-Company')" autofocus
                                    persistent-hint :items="AnaSirketler" v-model="AnaSirket" bottom></v-select>
                            </v-flex>
                            <!-- <v-flex xs12 v-if="sirkettipi==0" sm6 md3>
                               <v-btn v-on:click="greet">fatura bilgileri</v-btn>
                            </v-flex> -->
                            
                            <span class=" grey--text  title">{{$t('Subscription-Type')}}</span>
                            <v-divider></v-divider>
                            <v-radio-group v-model="pakettipi" row>
                                <v-radio :label="$t('Packages') " value="1"></v-radio>
                                <v-radio :label="$t('Additional-Credits')" value="2"></v-radio>
                            </v-radio-group>


                            <span v-if="pakettipi==1" class=" grey--text  title"> {{ $t('Package-Types') }} </span>
                            <v-divider v-if="pakettipi==1"></v-divider>
                            <v-radio-group v-if="pakettipi==1" v-model="aylikyillikpaketler" row>
                                <v-radio :label="$t('Monthly')" value='0'></v-radio>
                                <v-radio :label="$t('Annual')" value='1'></v-radio>
                            </v-radio-group>
                            <span v-if="urunekrani" class=" grey--text title"> {{$t('Product-packages-for-you')}}</span>

                            <v-divider></v-divider>
                            <span v-if="productshow.length==0" class=" grey--text  body-1">{{$t('Select-company-view-products')}}</span><br/>
                            <span class=" grey--text  body-1"> {{$t('EXTRA-PRODUCTS-PRICED')}}</span><a @click="dialogOdemeEkUcret = true" style="cursor: pointer;" class="font-weight-light info--text caption"><span class="info--text"> DETAYLAR İÇİN TIKLAYINIZ..</span></a>
                        </div>

                        <v-layout row wrap v-if="urunekrani">

                            <div v-for="item in productshow" v-bind:key="item.index">
                                <v-flex ma-1 xs12 sm4 md3>
                                    <v-hover>
                                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                            class="mx-auto" width="300">

                                            <v-flex xs12 sm12 md12>
                                                <v-card flat color="light-blue darken-4">
                                                    <v-layout pt-3 pb-3 justify-center>
                                                        <span
                                                            class="headline font-weight-  white--text">{{item.PaketAdi}}
                                                        </span>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>

                                            <v-card-title>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout row wrap justify-center>

                                                            <v-flex xs12 sm12 md12>
                                                                <v-layout pt-1 align-center="" justify-center>
                                                                    <div v-if="item.PaketTip==1"
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>flight</v-icon> {{item.BiletAdet}}
                                                                        {{ $t('Ticket') }}
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div v-if="item.PaketTip==1"
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>hotel</v-icon> {{item.CoperAdet}}
                                                                        Coper
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout justify-center>
                                                                    <div v-if="item.PaketTip==1"
                                                                        class="font-weight-bold grey--text subheading mb-2">
                                                                        <v-icon small>monetization_on</v-icon>
                                                                        {{item.CariAdet}} {{ $t('Current') }}
                                                                    </div>
                                                                </v-layout>
                                                                <v-layout v-if="item.PaketTip==1" justify-center>
                                                                    <v-btn flat @click="urundetayGetir(item)"
                                                                        color="info"> {{$t('Further-Information')}}</v-btn>
                                                                </v-layout>

                                                                <v-layout v-if="item.PaketTip==2" row wrap>
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-list>
                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{$t('Number-of-Tickets')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    1
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                     {{$t('Number-of-Void')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    5
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                   {{$t('Number-of-Refunds')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    1
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{$t('Number-of-Coper-PNRs')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    1
                                                                                                                    Kayıt
                                                                                                                    = 2
                                                                                                                    Kontör
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{$t('Number-of-Coper-PNRs-Cancelled')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    5
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{$t('Number-of-Visas')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    1
                                                                                                                    Kayıt
                                                                                                                    = 3
                                                                                                                    Kontör
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{$t('Current-Number')}}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    5
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                            <v-divider></v-divider>

                                                                            <v-layout row wrap>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout align-start
                                                                                        justify-start="">
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <div
                                                                                                    class="font-weight-thin grey--text body-1">
                                                                                                    {{ $t('Invoice-Number') }}
                                                                                                </div>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                                <v-flex xs6 sm6 md6>
                                                                                    <v-layout column="" align-start>
                                                                                        <v-card flat="">
                                                                                            <v-list-tile>
                                                                                                <v-list-tile-content>
                                                                                                    <v-layout
                                                                                                        align-center>
                                                                                                        <v-flex>
                                                                                                            <v-list-tile-sub-title>
                                                                                                                <v-layout
                                                                                                                    column
                                                                                                                    justify-start=""
                                                                                                                    align-start>
                                                                                                                    1
                                                                                                                </v-layout>
                                                                                                            </v-list-tile-sub-title>
                                                                                                        </v-flex>
                                                                                                    </v-layout>
                                                                                                </v-list-tile-content>
                                                                                            </v-list-tile>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>


                                                                        </v-list>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-divider></v-divider>
                                                                <v-layout justify-center>
                                                                    <v-text-field v-model="kontorAdet"
                                                                        v-if="item.PaketTip==2"
                                                                        label="Kontör Adedi Giriniz"></v-text-field>
                                                                </v-layout>
                                                                <v-layout v-if="item.PaketTip==1" justify-center>
                                                                    <span class="headline  font-weight-light red--text">{{item.Fiyat
                                                                        | moneyformat}}
                                                                        <span
                                                                            class="headline font-weight-light red--text">

                                                                            {{item.ParaBirimi | parabirimi}}</span></span>
                                                                </v-layout>
                                                                <v-layout v-if="item.PaketTip==2" justify-center>
                                                                    <span class="headline font-weight-light red--text">
                                                                        {{kontorAdet}} * {{item.Fiyat | moneyformat}}=
                                                                        {{toplamkontorFiyat | moneyformat}}
                                                                        {{item.ParaBirimi | parabirimi}}</span>

                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 ma-1 md12>
                                                        <v-btn block @click="Odeme(item,kontorAdet)" class="white--text"
                                                            color="green">
                                                            <v-icon small color="white"> shopping_cart</v-icon> &nbsp;
                                                            {{$t('Buy')}}
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>

                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </div>

                            <v-flex v-show="pakettipi==1 && productshow.length>0 " ma-1 xs2 sm1 md1>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                        class="mx-auto" width="300">


                                        <v-flex xs12 sm12 md12>

                                            <v-card flat color="red">
                                                <v-layout pt-3 pb-3 justify-center>
                                                    <span class="headline font-weight-  white--text"> {{ $t('Special') }}
                                                    </span>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>
                                        <v-card-title>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center>
                                                        <div>

                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s2')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s3')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div
                                                                    class="font-weight-light grey--text subheading mb-2">
                                                                    {{$t('Create-Special-Packages-s4')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text caption mb-2">
                                                                    &nbsp;</div>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <span
                                                                    class="caption pa-1  font-weight-light red--text">&nbsp;</span>
                                                            </v-layout>
                                                        </div>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 ma-1 md12>
                                                    <v-btn block class="white--text" color="green">
                                                        <v-icon small color="white">call</v-icon> &nbsp; +90 850 811 12
                                                        84
                                                    </v-btn>
                                                </v-flex>

                                            </v-layout>
                                        </v-card-title>

                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>


                        <v-layout v-if="odemeekrani" row wrap>

                            <v-layout row wrap>
                               <v-flex xs12 sm12 md12>
                                            <v-layout row wrap class=" project overdue">
                                                <v-toolbar flat="" size="100px" dark color="white">
                                                    <v-toolbar-title>
                                                        <span class="title black--text font-weight-">
                                                        {{$t('Payment')}}
                                                        </span>
                                                    </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                     <v-btn @click="urunleredon()" flat class="white--text" color="red">
                                            <v-icon>arrow_back_ios</v-icon> {{$t('Select-Product')}}
                                        </v-btn>
                                                </v-toolbar>
                                            </v-layout>
                                        </v-flex>

                            </v-layout>


                            <v-flex xs12 sm12 pt-2 md12>

                                   <v-card flat class="white--text">
                                    <v-layout row wrap>
                                          <v-flex pa-2 xs12 sm12 md12>
                                <v-radio-group :disabled="false" v-model="UrunKayit.OdemeTip" row>
                                    <v-radio :label="$t('Transfer-v3')" value="0"></v-radio>
                                    <v-radio :label="$t('Credit-Card')" value="1"></v-radio>
                                </v-radio-group>
                                          </v-flex>
                                    </v-layout>
                                   </v-card>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                                <v-card flat class="white--text">
                                    <v-layout row wrap>
                                        <v-flex v-if="kredikarti" pt-2 xs12 sm12 md6>
                                            <v-card flat="">
                                                <v-layout row wrap>

                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 pl-2 pt-2 sm12 md12>
                                                                <v-layout row wrap>
                                                                    <v-flex xs3 pl-2 sm3 md3>
                                                                        <v-layout justify-start>
                                                                         <span class=" red--text title">

                                                                             {{$t('Instalment-Rates')}}
                                                                        </span>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs3 sm3 md3>
                                                                         <v-layout justify-end row full-width>
                                                                        <div
                                                                            class="font-weight- grey--text subheading ">
                                                                            {{$t('Instalment-Amount')}}
                                                                        </div>
                                                                         </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs3 sm3 md3>
                                                                         <v-layout justify-end row full-width>
                                                                        <div
                                                                            class="font-weight- grey--text subheading ">
                                                                            {{$t('totalamount')}}
                                                                        </div>
                                                                         </v-layout>
                                                                    </v-flex>

                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs12 sm12 md9>
                                                                <v-layout justify-start>
                                                                    <v-divider></v-divider>
                                                                </v-layout>
                                                            </v-flex>
                                                              <v-flex xs12 sm3 md3>

                                                            </v-flex>

                                                            <v-flex xs3 sm3 md3>
                                                                <v-radio-group hide-details="" v-model="secilentaksit"
                                                                    :mandatory="false">
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-layout pl-4 row wrap="">
                                                                            <v-flex v-for="item in seciliozelOran"
                                                                                v-bind:key="item.id" xs12 pa-1 sm12
                                                                                md12>
                                                                                <v-radio :label="item.TaksitLabel"
                                                                                    v-bind:value="item">
                                                                                </v-radio>
                                                                            </v-flex>


                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-radio-group>
                                                            </v-flex>

                                                            <v-flex xs9 sm9 pt-4 md9>
                                                                <v-flex xs12 v-for="item in seciliozelOran"
                                                                    v-bind:key="item.id" sm12 md12>
                                                                    <v-layout row wrap="">
                                                                        <v-flex xs12 pa-1 sm6 md4>
                                                                            <v-layout justify-end row full-width>
                                                                            <span
                                                                                class="font-weight- grey--text subheading ">
                                                                                {{item.TaksitTutar | moneyformat}}
                                                                            </span>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                        <v-flex xs12 pa-1 sm6 md4>
                                                                             <v-layout justify-end row full-width>
                                                                            <div
                                                                                class="font-weight- grey--text subheading ">
                                                                                {{item.ToplamTutar | moneyformat}}
                                                                            </div>
                                                                             </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-flex>
                                                            <v-flex xs12 pa-3 sm12 md12><v-icon color="red">info</v-icon>
                                                <span class="red--text title">
                                                   {{ $t('Warning') }}</span><br />
                                                <v-divider></v-divider>
                                                <br/>
                                                <span class="grey--text ">
                                                    {{$t('For-Payment-Octet')}}</span> <span class="red--text">  OCTET </span> <span class="grey--text">{{$t('For-Payment-Octet-s2')}}</span>

                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-divider></v-divider>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 pt-2 v-if="!kredikarti" sm6 md6>

                                            <v-flex xs12 pa-2 sm12 md12>
                                                <v-layout justify-center="" fill-height="" align-center="">
                                                    <span class="grey--text title"> {{$t('Transfer-Confirmation')}}</span>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 pa-2 sm12 md12>
                                                <v-layout justify-center="" fill-height="" align-center="">
                                                    <span class="grey--text body-2"> * {{$t('Transfer-Confirmation-Confirm')}}
                                                        <span class="red--text font-weight-bold body-2">
                                                            ''{{havaleKodu}} '' </span> {{$t('Transfer-Confirmation-Confirm-s2')}}</span>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 pa-2 sm12 md12>
                                                <span class="black--text caption">
                                                    {{$t('Account-No')}}:</span><br />
                                                <v-divider></v-divider>
                                                <span class="grey--text caption">
                                                    GARANTİ BANKASI – METRO MECİDİYEKÖY ŞB.</span><br />
                                                <span class="grey--text caption">
                                                    ŞUBE KODU : 723 HESAP NO: 629 93 38</span><br />
                                                <span class="grey--text caption">
                                                    IBAN: TR46 0006 2000 7230 0006 2993 38</span>
                                            </v-flex>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <v-card flat class="white--text">
                                                <v-card flat="">
                                                    <v-card-actions>
                                                        <v-layout align-end="" row wrap>

                                                            <v-flex xs12 sm6 ma-2 md12>
                                                                <v-layout justify-center>
                                                                    <div>
                                                                        <v-layout justify-center>
                                                                            <div
                                                                                class="font-weight-light grey--text title mb-2">
                                                                                &nbsp;</div>
                                                                        </v-layout>
                                                                        <v-layout justify-center>
                                                                            <span
                                                                                class="display-1 font-weight-  grey--text">{{$t('Payment-Amount')}}
                                                                            </span>
                                                                        </v-layout>
                                                                        <v-divider></v-divider>
                                                                        <v-layout pt-2 justify-center>
                                                                            <div
                                                                                class="font-weight-regular red--text display-1 mb-2">
                                                                                {{toplamtutar | moneyformat}}
                                                                                {{parabirimi | parabirimi}}
                                                                            </div>
                                                                        </v-layout>

                                                                        <v-layout>
                                                                            <v-flex xs12 sm12>
                                                                                <v-layout row wrap>
                                                                                    <v-flex xs1 md1 sm1>

                                                                                        <v-layout align-start=""
                                                                                            justify-start fill-height>
                                                                                            <v-checkbox small
                                                                                                v-model="sozlesmeOnay"
                                                                                                hide-details
                                                                                                color="green">
                                                                                            </v-checkbox>
                                                                                        </v-layout>

                                                                                    </v-flex>

                                                                                    <v-flex xs11 md11 pt-4 sm11>
                                                                                        <a @click="sozlesme()"
                                                                                            style="cursor: pointer;"
                                                                                            class="font-weight-light grey--text caption "><span
                                                                                                class="info--text">
                                                                                                {{$t('I-Have-Sales-Contract')}}</span>.</a>
                                                                                        <span
                                                                                            class="font-weight-light grey--text caption">
                                                                                            {{$t('I-Have-Sales-Contract-s2')}}</span>

                                                                                    </v-flex>


                                                                                </v-layout>


                                                                            </v-flex>
                                                                        </v-layout>

                                                                        <v-layout row wrap justify-center>
                                                                            <v-flex pt-4 xs12 md12 sm12>
                                                                                <v-btn outline v-if="!kredikarti" block
                                                                                    class="white--text"
                                                                                    @click="SatinAl()" color="green">
                                                                                    {{$t('Confirm-Transfer')}}</v-btn>
                                                                                <v-btn outline v-if="kredikarti" block
                                                                                    class="white--text"
                                                                                    @click="KrediValidate()"
                                                                                    color="green">
                                                                                    {{$t('Make-Payment')}} &nbsp;<v-icon>
                                                                                        3d_rotation
                                                                                    </v-icon>
                                                                                </v-btn>
                                                                            </v-flex>

                                                                        </v-layout>

                                                                    </div>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-content>
            </div>

        <v-dialog v-model="dialogOdemeEkUcret" persistent max-width="900px">
            <v-card>
                <v-card-title style="background-color:#01579B">
                    <span class="headline white--text">Bilgilendirme</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <template>
                                <blockquote class="blockquote">
                                  {{ $t('info-v1') }}
                                </blockquote>
                                
                                <blockquote class="blockquote">
                                  {{ $t('info-v2') }}
                                </blockquote>

                                <blockquote class="blockquote">
                                  {{ $t('info-v3') }}
                                </blockquote>

                                <blockquote class="blockquote" style="max-width:800px">
                                  {{ $t('info-v4') }}
                                </blockquote>

                            </template>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="dialogOdemeEkUcret = false">{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


            <v-dialog v-model="dialogyenisirket" persistent max-width="350px">
                <v-card color="grey lighten-4">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">
                            <v-toolbar-title>{{$t('Add-New-Company')}}</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>


                    <v-flex pa-2 xs12 sm12 md12>
                        <v-form ref="formyenisirket" v-model="validyenisirket" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field :rules="[v => !!v || $t('Please-enter-title') ]" hide-details
                                        :label="$t('Company-Title')" v-model="yenisirketunvani">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-select item-value="UlkeID" :rules="[v => !!v || $t('Please-enter-country')]"
                                        hide-details item-text="UlkeAdi" :label="$t('Country-of-Your-Company')"
                                        persistent-hint :items="ulkeitems" v-model="secilenUlke" bottom></v-select>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-flex>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" v-if="!bekle" flat @click="sirketaciptal()">{{$t('Cancel')}}</v-btn>
                        <v-btn color="info" v-if="!bekle" flat @click="yenisirketac()">{{$t("save_button")}}</v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>



                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="odemebilgiDialog" persistent max-width="400px">
                <v-card color="grey lighten-5">


                    <v-flex pa-2 xs12 sm12 md12>
                        <v-form ref="formkredikarti" v-model="validkredikarti" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-alert v-model="alertkredikart" type="error">
                                        {{ $t('Complete-details-payment-process') }}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details :label="$t('Name_label')"
                                        v-model="PaymentForm.buyerName">
                                    </v-text-field>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details :label="$t('Surname_label')"
                                        v-model="PaymentForm.buyerSurname">
                                    </v-text-field>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details label="GSM"
                                        v-model="PaymentForm.buyerMobilePhone">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-flex>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" flat @click.native="odemebilgiDialog=false">{{$t('Cancel')}}</v-btn>
                        <v-btn color="info" flat @click="KrediValidate()"> {{ $t('Continue-the-process') }} </v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogurunDetay" scrollable="" max-width="400px">
                <v-card flat color="grey lighten-5">

                    <v-card-title> <span class=" grey--text font-weight-bold subheading"> &nbsp; {{urunDetay.PaketAdi}}
                            {{ $t('Package-features') }}
                             </span></v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                        <v-layout row wrap>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-list>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column align-center>
                                                                                <span class="font-weight-bold"> {{ $t('Program-Type') }} </span> </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>


                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justiy-start align-center>
                                                                                <span class="font-weight-bold"> {{ $t('Number') }}
                                                                                </span>
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Tickets')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.BiletAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                 {{$t('Number-of-Void')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.VoidAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                             {{$t('Number-of-Refunds')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.IadeAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Coper-PNRs')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.CoperAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                               {{$t('Number-of-Coper-PNRs-Cancelled')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.CoperIptalAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                              {{$t('Number-of-Visas')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.VizeAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Current-Number')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.CariAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{ $t('Invoice-Number') }}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                {{urunDetay.FaturaAdet}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>


                                    </v-list>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <span class=" red--text font-weight- caption"> &nbsp; {{$t('package-limits-need-to-buy')}} </span>
                            </v-layout>
                        </v-layout>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="dialogurunDetay=false">{{$t('Close')}}</v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>

        </v-app>
    </div>

</template>

<script>
    import auth from '../../../api/auth'
    import _ from 'underscore'
    import router from '../../../router'
    import genelsatissozlesme from "@/components/app/customcomp/genelsatissozlesme.vue"
    import altaciklama from "@/components/app/account/altaciklama.vue"
    import axios from 'axios'
    import helpers from "@/components/app/customcomp/helpers.js"
    import navi from "@/components/app/account/navigator.vue"
    import $ from '@/plugins/i18n.js'
    import {
        Trans
    } from '@/plugins/Translation'


    export default {
         data() {
        return {
            kayitliFatAdres:'',
            fatUnvan:'',
            fatVergiDairesi:'',
            fatVergiNo:'',
            fatUlke:'',
            fatSehir:'',
            fatIlce:'',
            fatPostaKod:'',
            fatAcikAdres:'',

            isFatValid:false,
            fatDialog:false,
            secilenTaskit3d:null,
            alertkredikart: true,
            odemebilgiDialog: false,
            validkredikarti: true,
            octetKrediKartiDialog: false,
            octetReturnUrl: null,
            alinanUrun: null,
            alinanAdet: 1,
            sozlesmeOnay: false,
            aylikyillikpaketler: '0',
            validyenisirket: true,
            ulkeitems: [],
            secilenUlke: 1,
            tekkontorFiyat: 0,
            toplamkontorFiyat: 0,
            kontorAdet: 1,
            urunDetay: {
                Aktif: null,
                BaslangicTarih: null,
                BitisTarih: null,
                CariAdet: null,
                CoperAdet: null,
                CoperIptalAdet: null,
                DonemAdet: null,
                FaturaAdet: null,
                Fiyat: null,
                IadeAdet: null,
                IndirimliFiyat: null,
                MusteriID: null,
                PaketAdi: null,
                PaketID: null,
                PaketTip: null,
                ToplamAdet: null,
                VizeAdet: null,
                VoidAdet: null,
            },
            dialogurunDetay: false,
            havaleKodu: null,
            ozelOranlar: [],
            seciliozelOran: null,
            cardimageLink: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
            cardimageLinkyedek: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
            secilentaksit: null,
            musteriidurun: null,
            pass: null,
            yedekresponse: [],
            bekle: false,
            AnaSirketlerWiev: [],
            AnaSirketler: [],
            Sirketler: [],
            AnaSirket: {},
            Sirket: {},
            giris: true,
            Urunler: false,
            urunlerlist: [],
            active: false,
            sektor: '0',
            pakettipi: '1',
            productshow: [],
            odemetipi: false,
            havale: true,
            kredikarti: false,
            odemeekrani: false,
            toplamtutar: 0,
            urunekrani: true,
            musteriid: null,
            dialogyenisirket: false,
            dialogOdemeEkUcret:false,
            yenisirketunvani: null,
            sirkettipi: '0',
            karttipi: [{
                    id: 'M',
                    text: 'Master Card'
                },
                {
                    id: 'VI',
                    text: 'VISA'
                },
                {
                    id: 'A',
                    text: 'American Express'
                },
            ],
            sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                '2029', '2030'
            ],
            dictionary: {
                custom: {
                    kartno: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                        min: this.$t('Card-Number-Must-16-Digits')
                    },

                    selectkarttipi: {
                        required: () => this.$t('Please-choose'),
                    },
                    kartcari: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanim: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanimyil: {
                        required: () => this.$t('Please-choose'),
                    },

                }
            },
            PaymentForm: {
                action: 'CREATE_COMMON_PAYMENT_PAGE_REQUEST',
                partnerCode: auth.OCTET_API_PARTNER_CODE,
                paymentAmount: 0,
                currency: 'TRY',
                expireDateTime: '',
                expireDateShowText: '',
                buyerName: null,
                buyerSurname: null,
                buyerMobilePhone: null,
                buyerEmail: null,
                buyerTCKN: 0,
                buyerCompanyName: '',
                returnPage: null,
                buyerTaxOffice: '',
                buyerTaxNumber: '',
                language: 'TR',
                apiReferenceID: '',
                apiReferenceInfo: '',
                sellerReference:'',
                consumerCardInstallmentLimit: '',
                commercialCardInstallmentLimit: '',
                secretKey:null, // auth.OCTET_API_SECRET_KEY,
                refId: null
            },
            itemsnavi: [{
                    icon: 'business',
                    text: this.$t('Corporate-transactions'),
                    to: 'anasirket',
                },
                {
                    icon: 'people',
                    text: this.$t('Member-Transactions'),
                    to: 'login-uye'
                },
                {
                    icon: 'people',
                    text: this.$t('Authority-Groups'),
                    to: 'login-yetkigruplist'
                }
            ],
            clipped: true,
            drawer: true,
            fixed: false,
            miniVariant: false,
            right: true,
            rightDrawer: false,
            binResult: {
                Bin: null,
                Dkk: null,
                KartBanka: null,
                KartOrg: null,
                KartTip: null,
                SanalPosId: null,
            },
            MusteriUrun: {
                ID: null,
                MusteriID: null,
                PaketBilgi: {
                    PaketID: null,
                    PaketTip: null,
                },
                OdemeBilgi: {
                    ID: null,
                    OdemeTip: 0,
                    OdemeOnay: false
                },
                BaslangicTarih: null,
                BitisTarihi: null,
                KontorAdet: 0,
                KalanKontorAdet: 0,
                BiletAdet: 0,
                FaturaAdet: 0,
                CariAdet: 0,
                IadeAdet: 0,
                VoidAdet: 0,
                CoperAdet: 0,
                CoperIptalAdet: 0,
                VizeAdet: 0,
            },
            UrunKayit: {
                ID: null,
                Aciklama: null,
                OdemeTip: '0', // 0 Havale 1 Kredi
                OdemeOnay: false,
                Tarih: null,
                Tutar: 0,
                Banka: null,
                TaksitAdet: null,
                VadeFarki: null,
                VadeTarihi: null,
                CariKod: null,
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: null,
                IslemID: null,
                GuID: null,
                SiparisID: null,
                DekontID: null,
                UlkeID: null,
            },
            mevcutsirketmi: true,
            yenisirket: false,
            dialog: false,
            items: [{
                    icon: 'domain',
                    text: this.$t('Corporate-transactions')
                },
                {
                    icon: 'contacts',
                    text: this.$t('Member-Transactions')
                },
            ],
            faturainfo: [],
            newuserstatus: false,
            loginstatus: true,
            e1: 0,
            e2: true,
            e3: true,
            e4: true,
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('Wrong-e-mail')
                }
            },
            Kartbilgisi: null,
            YeniKullanici: {
                UserID: null,
                MusteriID: 0,
                KullaniciAdi: null,
                Email: null,
                Sifre: null,
                Tip: 0,
                AdSoyad: null,
                Deleted: false,
                Aktif: false,
                MusteriBilgi: [],
                OdemeOnay: false,
            },
            unvan: null,
            confirm: null,
            Credential: {
                email: '',
                password: ''
            },
            valid: true,
            validOdeme: true,
            errorMsg: '',
            errorAlert: false
        }
        },
        props: {
            source: String
        },
        methods: {
            greet: function () {

      this.fatDialog=true
      //this.FaturaBilgileriKontrol();
    },
  
            getir(params) {
                var a;
                const requestOptions = {

                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: params
                };
                fetch(auth.OCTET_API_URL, requestOptions)
                    .then(response => response.json())
                    .then(data => a = data.id);
            },


            sozlesme() {
                this.$refs.genelsatissozlesme.open(this.AnaSirket, this.alinanUrun, this.alinanAdet).then(
                    sonuc => {

                    });

            },
            getimage(a) {
                return helpers.getimage(a);
            },
            urundetayGetir(val) {
                this.dialogurunDetay = true
                this.urunDetay = val
            },
            ConvertStringToHex(str) {
                var arr = [];
                for (var i = 0; i < str.length; i++) {
                    arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
                }
                return "\\u" + arr.join("\\u");

            },

            KrediValidate() {
                if (this.sozlesmeOnay == true) {

                    if (this.PaymentForm.buyerName != null && this.PaymentForm.buyerSurname != null && this
                        .PaymentForm
                        .buyerMobilePhone != null) {

                        this.KrediOdemeYap();
                        this.odemebilgiDialog = false

                    } else {

                        var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

                        if (ml != null) {
                            if(ml.UserInfo.GSM != null && ml.UserInfo.GSM != ""){
                                this.PaymentForm.buyerMobilePhone = ml.UserInfo.GSM
                                this.PaymentForm.buyerName = ml.UserInfo.AdSoyad
                                this.PaymentForm.buyerSurname = ml.UserInfo.AdSoyad
                                this.PaymentForm.buyerEmail = ml.UserInfo.Email
                            }
                        }

                        if (this.PaymentForm.buyerName != null && this
                            .PaymentForm.buyerSurname != null && this.PaymentForm.buyerMobilePhone != null) {
                            this.KrediOdemeYap();
                            this.odemebilgiDialog = false

                        } else {
                            this.odemebilgiDialog = true
                        }

                    }

                } else {
                    this.text1 = this.$t('You-need-approve-contract')
                    this.snackbar = true
                }


            },
            KrediOdemeYap() {


                this.PaymentForm.paymentAmount = helpers.roundNumber(this.toplamtutar, 2);
                this.PaymentForm.refId = this.defaultKod(8);
                this.PaymentForm.apiReferenceID=this.defaultKod(8)
                this.PaymentForm.sellerReference = "MID=" +this.musteriidurun + " PID=" + this.MusteriUrun.PaketBilgi.PaketID + " PTip=" +  this.pakettipi + " KAdet=" + this.kontorAdet + " PAdi=" + this.alinanUrun
                if(this.PaymentForm.sellerReference.length > 50){
                        this.PaymentForm.sellerReference = this.PaymentForm.sellerReference.substring(0,49)
                }
                
                if (this.secilentaksit != null) {

                    if (this.secilentaksit.TaksitAdet != 0 && this.secilentaksit.TaksitAdet != null) {
                        this.PaymentForm.consumerCardInstallmentLimit = this.secilentaksit.TaksitAdet
                    } else {
                        this.PaymentForm.consumerCardInstallmentLimit = 1;
                    }
                } else {
                    this.PaymentForm.consumerCardInstallmentLimit = 1;

                }
               
               this.PaymentForm.returnPage='https://nextapiv2.arkman.com.tr/OctetView/Index/?&musteriid='+this.musteriidurun+'&paketid='+this.MusteriUrun.PaketBilgi.PaketID+'&pakettip='+this.pakettipi+'&kontoradet='+this.kontorAdet+'&urunaciklama='+this.alinanUrun
                // this.PaymentForm.returnPage='http://localhost:9000/OctetView/Index/?&musteriid='+this.musteriidurun+'&paketid='+this.MusteriUrun.PaketBilgi.PaketID+'&pakettip='+this.pakettipi+'&kontoradet='+this.kontorAdet+'&urunaciklama='+this.alinanUrun

                var params2 = this.PaymentForm
                this.$http.post(auth.API_URL + 'api/Payment/OctetRequest', params2, {
                    headers: {}
                }).then((response) => {

                    if (response.body.Status) {
                        this.octetKrediKartiDialog = true
                        this.octetReturnUrl = response.body.Data.resultData.commonPaymentPageURL
                    } else {
                        this.text1 = response.body.ResponseMessage
                        this.snackbar = true
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-KartOde'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-KartOde'
                        this.snackbar = true
                    }
                })

            },

            dildegistir(a) {
                if (a == null || a == '') {
                    a = 'tr'
                }

                const lang = a
                const to = this.$router.resolve({
                    params: {
                        lang
                    }
                })
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location)
                    this.locale = e
                })

            },
            logout() {
                auth.logout()
            },
            yenisirketac() {
                if (this.$refs.formyenisirket.validate()) {
                    this.bekle = true;

                    var response1 = JSON.parse(window.localStorage.getItem('response'));

                    if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
                        var params = {
                            Mail: response1.Email,
                            CustomerInfo: {
                                Ad: this.yenisirketunvani,
                                UlkeID: this.secilenUlke
                            }
                        }

                        this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {

                            this.text1 = response.body.ResponseMessage
                            this.snackbar = true


                            if (response.body.Status == true) {
                                this.productshow = []
                                this.text1 =
                                    'Yeni ana şirket kayıt işleminiz tamamlandı ve şirketinize 10 günlük ücretsiz üyelik tanımlanmıştır.'
                                this.snackbar = true
                                this.dialogyenisirket = false;
                                this.AnaSirket = null;
                                this.sirkettipi = '0';
                                this.bekle = false;


                                var params = {
                                    Email: response1.Email

                                }
                                this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                                    headers: {
                                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                                    }
                                }).then((response) => {

                                    this.giris = true
                                    this.Urunler = false

                                    this.bekle = false;
                                    this.yedekresponse = response1
                                    window.localStorage.removeItem('response')

                                    var sirketlers = []
                                    Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                                        var anasirket = {
                                            Ad: response.body[0].MusteriBilgi[key]
                                                .Ad,
                                            GenelSirketler: response.body[0]
                                                .MusteriBilgi[
                                                    key]
                                                .Sirketler,
                                            MusteriId: response.body[0]
                                                .MusteriBilgi[key]
                                                .MusteriID,
                                            MusteriKod: response.body[0]
                                                .MusteriBilgi[key]
                                                .MusteriKod
                                        }
                                        sirketlers.push(anasirket)
                                    });

                                    var newresponse = {
                                        AdSoyad: this.yedekresponse.AdSoyad,
                                        Email: this.yedekresponse.Email,
                                        MusteriDbler: sirketlers,
                                        Token: this.yedekresponse.Token,
                                        UserId: this.yedekresponse.UserId
                                    }
                                    window.localStorage.setItem('response', JSON.stringify(
                                        newresponse));

                                    this.guncelle();


                                }, (response) => {
                                    if (response.status === 0) {
                                        this.bekle = false;

                                        this.text1 = 'Service Unavailable-WebUserList'
                                        this.snackbar = true
                                    } else {
                                        this.text1 = 'Service Unavailable-WebUserList'
                                        this.snackbar = true
                                    }
                                })
                            }

                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-NewCustomerAdd'
                                this.bekle = false;

                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-NewCustomerAdd'
                                this.bekle = false;

                                this.snackbar = true
                            }
                        })

                    } else {
                        this.text1 = this.$t('Please-enter-corporate-title')
                        this.snackbar = true
                        this.bekle = false;

                    }
                }
            },
            sirketaciptal() {
                this.dialogyenisirket = false;
                this.sirkettipi = '0';
            },
            urunleredon() {
                this.urunekrani = true;
                this.odemeekrani = false;
            },
            sirketleredon() {
                this.Urunler = false;
                this.giris = true;
            },
            Odeme(val, adet) {
//                 this.FaturaBilgileriKontrol();
// if (this.kayitliFatAdres=='' || this.kayitliFatAdres==undefined)
// {
//     fatDialog=true;
//     return;
console.log(val);
// }

                if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof (this
                        .sirkettipi) !=
                    'object') {

                    if (val.PaketTip == 2) {
                        this.UrunKayit.Tutar = val.Fiyat * adet
                        this.toplamtutar = this.UrunKayit.Tutar
                    } else {
                        this.UrunKayit.Tutar = val.Fiyat
                        this.parabirimi = val.ParaBirimi
                        this.toplamtutar = this.UrunKayit.Tutar

                    }



                    this.alinanUrun = val.PaketAdi
                    this.alinanAdet = adet

                    this.MusteriUrun.PaketBilgi.PaketID = val.PaketID
                    // this.MusteriUrun.BiletAdet=val.BiletAdet;
                    // this.MusteriUrun.CariAdet=val.CariAdet;
                    // this.MusteriUrun.CoperAdet=val.CoperAdet;
                    // this.MusteriUrun.CoperIptalAdet=val.CoperIptalAdet;
                    // this.MusteriUrun.FaturaAdet=val.FaturaAdet;
                    // this.MusteriUrun.IadeAdet=val.IadeAdet;
                    
                    this.odemeekrani = true;
                    this.urunekrani = false;
                    this.havaleKodu = this.defaultKod(8);



                } else {
                    this.text1 = 'Lütfen Şirket Seçiniz'
                    this.snackbar = true
                }


            },
            defaultKod(length) {

                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                    const rnd = Math.floor(Math.random() * 90000) + 10000;
                    return result + rnd;
                }
            },
            FaturaBilgileriKontrol(){
                if (this.musteriidurun!=null && this.musteriidurun!='') 
                {
                    var prms= {
             ID:this.musteriidurun
            }
            var params=prms;
            this.$http.post(auth.API_URL + 'api/Awed/MusteriIDSearch', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
}).then((response) => {

    if (response.statusText=='OK') {
        this.kayitliFatAdres=response.body[0].Adres
    } else {
        this.text1 = response.statusText + ' ' + 'Fatura Bilgileriniz Kontrol Edilemedi';
        this.snackbar = true
    }
})
         }},
            FaturaBilgileriGuncelle() {
                if (this.musteriidurun!=null && this.musteriidurun!='') {
                    var prms= {
            Ulke:this.fatUlke,
            Sehir:this.fatSehir,
            Ilce:this.fatIlce,
            Adres:this.fatAcikAdres + ' ' + this.fatUnvan + ' ' + this.fatVergiDairesi + ' ' + this.fatVergiNo + ' ' + this.fatPostaKod ,
            MusteriID:this.musteriidurun
            }

var params = prms

this.$http.post(auth.API_URL + 'api/Awed/MusteriUpdateInvoiceAdress', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
}).then((response) => {
console.log(response);
    if (response.statusText=='OK') {

        this.text1 = 'Fatura Bilgileriniz Güncellendi'
        this.snackbar = true
    } else {
        this.text1 = response.body.ResponseDescription
        this.snackbar = true
    }


}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable-Invoice'
        this.snackbar = true
    } else {
        this.text1 = 'Service Unavailable-Invoice'
        this.snackbar = true
    }
})
}
this.fatDialog=false;
},
          

           
            SatinAl() {


                if (this.sozlesmeOnay == true) {
                       
                   

                    this.UrunKayit.Tarih = getDateNow()
                    this.UrunKayit.OdemeOnay = false
                    this.UrunKayit.Aciklama = this.havaleKodu

                    var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

                    var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == this.musteriidurun)

                    this.UrunKayit.UlkeID = manageload.AnaSirketInfo[index].UlkeID

                    var params = this.UrunKayit

                    this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        if (response.body.Status == true) {

                            if (response.body.SaveID != null && response.body.SaveID != '') {

                                this.MusteriUrun.MusteriID = this.musteriidurun
                                this.MusteriUrun.PaketBilgi.PaketTip = this.pakettipi
                                this.MusteriUrun.OdemeBilgi.ID = response.body.SaveID
                                this.MusteriUrun.OdemeBilgi.OdemeTip = this.UrunKayit.OdemeTip
                                this.MusteriUrun.OdemeBilgi.OdemeOnay = false
                                this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID

                                if (this.pakettipi == 2) {
                                    this.MusteriUrun.KontorAdet = this.kontorAdet
                                    this.MusteriUrun.KalanKontorAdet = this.kontorAdet
                                    this.MusteriUrun.BaslangicTarih = getDateNow()
                                    this.MusteriUrun.BitisTarihi = getDateNow()
                                } else {
                                    this.MusteriUrun.KontorAdet = 0
                                    this.MusteriUrun.KalanKontorAdet = 0
                                    this.MusteriUrun.BaslangicTarih = null
                                    this.MusteriUrun.BitisTarihi = null
                                }
                                var params = this.MusteriUrun


                                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerSave',
                                    params, {
                                        headers: {
                                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                                        }
                                    }).then((response) => {

                                    this.text1 = response.body.ResponseMessage
                                    this.snackbar = true

                                    if (response.body.Status == true) {

                                        setTimeout(function () {
                                            var url = '#/anasirket'
                                            window.open(url, '_self')
                                        }.bind(this), 4000)

                                    }


                                }, (response) => {
                                    if (response.status === 0) {
                                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                                        this.snackbar = true
                                    } else {
                                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                                        this.snackbar = true
                                    }
                                })


                            } else {
                                this.text1 =
                                    'Ödeme kayıt işlemi tamamlandı. Ürün kullanıcınıza tanıtılamadı. Lüfen destek ekibine ulaşınız.'
                                this.snackbar = true
                            }

                        } else {
                            this.text1 = response.body.ResponseMessage
                            this.snackbar = true

                        }


                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-ProductCustomerSave'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-ProductCustomerSave'
                            this.snackbar = true
                        }
                    })
                } else {
                    this.text1 = this.$t('You-need-approve-contract')
                    this.snackbar = true
                }
            },
            BinKodSorgula() {
                var params = this.PaymentForm

                this.$http.post(auth.API_URL + 'api/ParamPos/GetBinCode', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.binResult = response.body

                    this.seciliozelOran = []

                    this.ozelOranlar.forEach(element => {

                        if (this.binResult.SanalPosId == element.SanalPosId) {

                            this.cardimageLink = element.KrediKartiBankaGorsel


                            element.TaksitOranlar.forEach(element1 => {


                                if (element1.Oran > -1) {

                                    var Tutar = (this.toplamtutar * element1.Oran /
                                            100) + this
                                        .toplamtutar
                                    var taksittutar = Tutar / element1.Taksit

                                    var taksitlabel = null

                                    if (element1.Taksit == 1) {
                                        taksitlabel = "Tek Çekim"
                                    } else {
                                        taksitlabel = element1.Taksit + "Taksit"
                                    }


                                    var taksitbilgi = {
                                        TaksitLabel: taksitlabel,
                                        TaksitAdet: element1.Taksit,
                                        SanalPosId: element.SanalPosId,
                                        TaksitTutar: taksittutar,
                                        ToplamTutar: Tutar
                                    }


                                    this.seciliozelOran.push(taksitbilgi)

                                }

                            });
                            this.secilentaksit = this.seciliozelOran[0]

                        }

                    });




                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })


            },
            KartOdemesiYap() {},
            urunleregit() {
                this.AnaSirket = null
                this.giris = false
                this.Urunler = true

                var params = {
                    PaketID: null,
                    PaketTip: 0,
                    MusteriID: null,
                    AktifKontrolYapma: null,
                    UlkeID: 1
                }

                this.$http.post(auth.API_URL + 'api/Register/PackageList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.urunlerlist = response.body
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 1 && element.DonemAdet == 1)
                            this.productshow.push(element)
                    });
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductList'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductList'
                        this.snackbar = true
                    }
                })

            },
            sysLogin,
            getDateNow,
            guncelle,
            userlist
        },
        filters: {
            parabirimi: function (p) {
                if (p == 'TRY') {
                    return ' ₺'
                } else if (p == 'EUR') {
                    return ' €'
                } else if (p == 'USD') {
                    return ' $'
                }
            },
            dateformat: function (t) {
                return helpers.dateformat(t);
            },
            moneyformat: function (m) {
                return helpers.moneyformat(m);
            },

            bakiyekontrol: function (m) {
                return helpers.bakiyekontrol(m);
            }

        },
        beforeMount: beforeMount,
        components: {
            'navi': navi,
            altaciklama,
            genelsatissozlesme
        },

        watch: {
            'aylikyillikpaketler': function (value) {

                if (value == 1) {

                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 1 && element.DonemAdet == 12)
                            this.productshow.push(element)
                    });



                } else {

                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 1 && element.DonemAdet == 1)
                            this.productshow.push(element)
                    });

                }
            },

            'secilentaksit': function (value) {
                this.toplamtutar = value.ToplamTutar
            },
            'PaymentForm.CardNumber': function (value) {
                if (value.length > 5) {
                    this.BinKodSorgula();
                }

                if (value.length < 6) {
                    this.binResult.KartBanka = null
                    this.seciliozelOran = []
                    this.cardimageLink = this.cardimageLinkyedek
                    this.toplamtutar = this.UrunKayit.SatisTutar
                }
            },
            'pakettipi': function (value) {
                if (value == '1') {

                    if (this.aylikyillikpaketler == "0") {
                        this.productshow = [];
                        this.urunlerlist.forEach(element => {
                            if (element.PaketTip == 1 && element.DonemAdet == 1) {
                                this.productshow.push(element)
                            }
                        });


                    } else {

                        this.productshow = [];
                        this.urunlerlist.forEach(element => {
                            if (element.PaketTip == 1 && element.DonemAdet == 12) {
                                this.productshow.push(element)
                            }
                        });
                    }

                } else {
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.PaketTip == 2) {
                            this.productshow.push(element)
                            this.toplamkontorFiyat = this.kontorAdet * element.Fiyat
                            this.tekkontorFiyat = element.Fiyat
                        }
                    });

                }
            },
            'kontorAdet': function (value) {
                var a = parseInt(value)
                if (Number.isInteger(a)) {

                    this.toplamkontorFiyat = value * this.tekkontorFiyat
                } else {
                    this.kontorAdet = 1

                }

            },
            'UrunKayit.OdemeTip': function (value) {
                this.toplamtutar=this.UrunKayit.Tutar
                if (value == '0') {
                    this.havale = true;
                    this.kredikarti = false;
                } else {

                    this.havale = false;
                    this.kredikarti = true;
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


                    var params1 = {
                        CompanyCode: 1,
                        PosCode: 'OCT',
                        arkmanPayment:'true',
                    }

                    this.$http.post(auth.API_URL + 'api/BankPos/Get', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.seciliozelOran = []

                        this.ozelOranlar = response.body.Taksitler


                        this.ozelOranlar.forEach(element1 => {


                            var Tutar = (this.toplamtutar * element1.VadeFarkYuzdeSatis / 100) +
                                this
                                .toplamtutar

                            var taksittutar = Tutar / element1.TaksitAdet



                            var taksitbilgi = {
                                TaksitLabel: element1.TaksitAciklama,
                                TaksitAdet: element1.TaksitAdet,
                                TaksitTutar: taksittutar,
                                ToplamTutar: Tutar
                            }


                            this.seciliozelOran.push(taksitbilgi)



                        });

                        this.secilentaksit = this.seciliozelOran[0]


                    }, (response) => {
                      if (response.status === 0) {
                          this.text1 = 'Service Unavailable-BankPos'
                          this.snackbar = true
                      } else {
                          this.text1 = 'Service Unavailable-BankPos'
                          this.snackbar = true
                      }
                    })
                }
            },
            'AnaSirket': function (value) {
                if (value != null) {
                    this.AnaSirketler.forEach(element => {

                        if (element.id == value) {
                            this.musteriidurun = element.musteriid
                            var manageload = JSON.parse(window.localStorage.getItem(
                                'WebUserManageLoad'));
                            var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID ==
                                element
                                .musteriid)



                            if (index != -1) {
                                var params = {
                                    PaketID: null,
                                    PaketTip: 0,
                                    MusteriID: null,
                                    UlkeID: manageload.AnaSirketInfo[index].UlkeID,
                                    AktifKontrolYapma: null
                                }

                                this.$http.post(auth.API_URL + 'api/Register/PackageList', params, {
                                    headers: {
                                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                                    }
                                }).then((response) => {
                                    this.urunlerlist = response.body
                                    this.productshow = [];
                                    this.urunlerlist.forEach(element => {
                                        if (element.PaketTip == 1 && element
                                            .DonemAdet !=
                                            12)
                                            this.productshow.push(element)
                                    });
                                             if (this.aylikyillikpaketler == 1) {
                                            this.productshow = [];
                                            this.urunlerlist.forEach(element => {
                                                if (element.PaketTip == 1 && element.DonemAdet == 12)
                                                    this.productshow.push(element)
                                            });

                                        } else {
                                            this.productshow = [];
                                            this.urunlerlist.forEach(element => {
                                                if (element.PaketTip == 1 && element.DonemAdet == 1)
                                                    this.productshow.push(element)
                                            });

                                        }
                                }, (response) => {
                                    if (response.status === 0) {
                                        this.text1 = 'Service Unavailable-ProductList'
                                        this.snackbar = true
                                    } else {
                                        this.text1 = 'Service Unavailable-ProductList'
                                        this.snackbar = true
                                    }
                                })

                            } else {
                                this.text1 = 'Fiyat listesi için şirkete ait ülke kodu bulunamadı'
                                this.snackbar = true
                            }


                        }
                    });
                }
            },
            'sirkettipi': function (value) {
                if (value == '0') {
                    this.mevcutsirketmi = true;
                    this.yenisirket = false;
                    this.dialogyenisirket = false;

                } else {
                    this.dialogyenisirket = true;
                    this.mevcutsirketmi = false;
                    this.yenisirket = true;

                    this.$http.post(auth.API_URL + 'api/Awed/WebCountryList', null, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.ulkeitems = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-WebCountryList'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-WebCountryList'
                            this.snackbar = true
                        }
                    })

                }
            }

        }

    }

    function beforeMount() {




        this.AnaSirket = null
        var sirketlers = []

        var response1 = JSON.parse(window.localStorage.getItem('response'));

        Object.keys(response1.MusteriDbler).forEach(key => {
            var sirket = {
                text: response1.MusteriDbler[key].Ad,
                id: response1.MusteriDbler[key].MusteriKod,
                musteriid: response1.MusteriDbler[key].MusteriId,
                baglisirketler: response1.MusteriDbler[key].GenelSirketler
            }
            sirketlers.push(sirket)
        });

        this.AnaSirketler = sirketlers;
        this.AnaSirket = this.$route.query.sirket

    }

    function guncelle() {

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))

            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));


            var sirketlers = []

            Object.keys(response1.MusteriDbler).forEach(key => {

                var sirket = {
                    text: response1.MusteriDbler[key].Ad,
                    id: response1.MusteriDbler[key].MusteriKod,
                    musteriid: response1.MusteriDbler[key].MusteriId,
                    baglisirketler: response1.MusteriDbler[key].GenelSirketler
                }
                sirketlers.push(sirket)
            });

            this.AnaSirketler = sirketlers;

            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;
                }).indexOf(element.id);
                var id = element.id;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler

                var params = {
                    MusteriInfo: {
                        MusteriKod: element.id
                    }
                }
                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if (response.body.UyelikStatus != true) {
                        active = false
                    }

                    var sirket = {
                        id: id,
                        text: text,
                        UyelikBitis: response.body.UyelikBitis,
                        UyelikTip: response.body.UyelikTip,
                        KalanKontor: response.body.KalanKontor,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        active: active
                    }
                    yedeklist.push(sirket)
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    }
                })
            });

            this.AnaSirketlerWiev = yedeklist


        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }

    function userlist() {

        var response = JSON.parse(window.localStorage.getItem('response'));

        var userparams = {
            Email: response.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserConnList'
                this.snackbar = true
            }
        })

    }

    function sysLogin(userId, musteriId, anasirketid, sirketler) {

        if (sirketler.length > 0) {
            var response = JSON.parse(window.localStorage.getItem('response'));

            var earsiv = 0
            var efatura = 0
            this.Sirket.id = sirketler[0].SirketKodu
            this.Sirket.text = sirketler[0].SirketAdi
            this.Sirket.unvan = sirketler[0].SirketUnvani

            var sirketparams = {
                SirketKodu: this.Sirket.id
            }

            this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                earsiv = response.body.OpsiyonBilgileri.EArsiv
                efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

                var credentials = {
                    AnaSirketKodu: anasirketid,
                    MusteriID: musteriId,
                    UserID: userId,
                    SirketKodu: this.Sirket.id,
                    SirketAdi: this.Sirket.text,
                    SirketUnvani: this.Sirket.unvan,
                    Sirketler: sirketler,
                    EArsiv: earsiv,
                    EFatura: efatura,
                    CoperSirketNo: 0,
                }

                window.localStorage.setItem('credentials', JSON.stringify(credentials));

                window.localStorage.removeItem('sirketler')

                var response = JSON.parse(window.localStorage.getItem('response'));

                var credential = {
                    Email: response.Email,
                    Password: this.pass,
                    ActiveMusteriKod: anasirketid
                }
                auth.logingiris(this, credential, this.$route.query.redirect)

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Company Get'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                } else {

                    this.text1 = 'Service Unavailable-Company Get'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                }
            })

        } else {
            this.text1 = this.$t('No-sub-company-for-parent-company')
            this.snackbar = true
        }



    }
</script>
<style scoped>
    a.menu_links {
        cursor: pointer;
    }
</style>